import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NavController } from '@ionic/angular';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { DxTextBoxTypes } from 'devextreme-angular/ui/text-box';
import { AutentificacionService } from 'src/app/_services/autentificacion.service';
import { FocusService } from 'src/app/_helpers/focus.service';
import { ValidacionForm } from 'src/app/_helpers/validacion-form.service';
import { Common } from 'devextreme-angular';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { RolUsuario } from 'src/app/_models/_enums/rolUsuario.enum';
import { SnackBarService } from 'src/app/_helpers/snack-bar.service';

@Component({
  selector: 'app-acceso',
  templateUrl: './acceso.component.html',
  styleUrls: ['./acceso.component.scss'],
  standalone: false,
})
export class AccesoComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() RestablecerContrasena = new EventEmitter<void>();
  @Output() Acceso2FA = new EventEmitter<{ correo: string; clave: string }>();

  private formBuilder = inject(FormBuilder);
  public validacionService = inject(ValidacionForm);
  public focusService = inject(FocusService);
  private elementRef = inject(ElementRef);
  private autentificacionService = inject(AutentificacionService);
  private navCtrl = inject(NavController);
  private responsive = inject(BreakpointObserver);
  private snackBarService = inject(SnackBarService);

  loading = false;
  errores: { [key: string]: string } = {};

  stylingMode: Common.EditorStyle = 'outlined';
  labelMode: Common.LabelMode = 'floating';
  passwordMode: DxTextBoxTypes.TextBoxType = 'password';
  passwordButton: DxButtonTypes.Properties = {
    icon: 'eyeopen',
    stylingMode: 'text',
    onClick: () => {
      this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
      this.passwordButton.icon =
        this.passwordMode === 'text' ? 'eyeclose' : 'eyeopen';
    },
  };

  esResolucionMovil = !this.responsive.isMatched(Breakpoints.WebLandscape);
  destroy$ = new Subject<void>();

  loginForm = this.formBuilder.group({
    correo: new FormControl<string>('', [
      Validators.required,
      Validators.email,
    ]),
    clave: new FormControl<string>('', Validators.required),
    recordar: new FormControl<boolean>(false, { nonNullable: true }),
  });

  constructor() {}

  ngOnInit() {
    this.responsive
      .observe([Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.esResolucionMovil = false;
        } else {
          this.esResolucionMovil = true;
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusService.focusPrimerCampo(this.elementRef);
    }, 200);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Funcion que se ejecuta en cada envío del formulario
  onSubmit() {
    this.validacionService.markFormGroupTouched(this.loginForm);

    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    const datosLogin = this.loginForm.value;

    //Comprobar si tiene 2FA activado el usuario

    this.autentificacionService
      .obtenerDobleFactorValidacion(datosLogin.correo, datosLogin.clave)
      .subscribe({
        next: (tieneDobleFactor) => {
          if (tieneDobleFactor === true) {
            //TIENE 2FA ACTIVADO
            //Funcion para recibir el correo con el código
            this.autentificacionService
              .enviarCodigoInicioFA(datosLogin.correo)
              .subscribe({
                next: (response) => {
                  this.snackBarService.showSuccess(
                    'Se ha enviado un correo con el código de acceso.',
                  );
                },
                error: (error) => {
                  this.snackBarService.showError(error.error);
                },
              });
            this.loading = false;
            //Mostrar el form para introducir el codigo
            this.Acceso2FA.emit({
              correo: datosLogin.correo!,
              clave: datosLogin.clave!,
            });
          } else {
            //NO TIENE 2FA ACTIVADO
            this.autentificacionService
              .login(datosLogin.correo, datosLogin.clave, datosLogin.recordar)
              .subscribe({
                next: (response) => {
                  if (response) {
                    this.loginForm.reset();
                    // Si el usuario es rol proveedor, redirige a la ficha de su proveedor, caso contrario al inicio
                    if (response.rol === RolUsuario.Proveedor) {
                      this.navCtrl.navigateRoot([
                        `/proveedores/proveedor-ficha/${response.idProveedor}`,
                      ]);
                    } else {
                      this.navCtrl.navigateRoot(['/']);
                    }
                  } else {
                    //Marcar el formulario como inválido
                    this.loginForm.invalid;
                  }
                },
                error: (error) => {
                  //this.snackBarService.showError(error.error);
                },
              });
              this.loading = false;
          }
        },
        error: (error) => {
          // Gestionar errores especificos de login
          if (error.status === 401 || error.status === 404) {
            this.loginForm.controls.correo.setErrors({
              credencialesInvalidas: true,
            });
            this.loginForm.controls.clave.setErrors({
              credencialesInvalidas: true,
            });
          } else if (error.status === 403) {
            this.loginForm.controls.correo.setErrors({
              accesoDenegado: true,
            });
          }

          //Mostrar mensaje de error
          //this.snackBarService.showError(error.error);
          this.loading = false;
        },
      });

    // if (dobleFactor) {
      // //Funcion para recibir el correo con el código
      // this.autentificacionService.enviarCodigoInicioFA(datosLogin.correo).subscribe({
      //   next: (response) => {
      //     this.snackBarService.showSuccess(
      //       'Se ha enviado un correo con el código de acceso.',
      //     );
      //   },
      //   error: (error) => {
      //     this.snackBarService.showError(error.error);
      //   },
      // });
      // this.loading = false;
      // //Mostrar el form para introducir el codigo
      // this.Acceso2FA.emit(datosLogin.correo);
    // } else {
      //Login normal
      // this.autentificacionService
      //   .login(datosLogin.correo, datosLogin.clave, datosLogin.recordar)
      //   .subscribe({
      //     next: (response) => {
      //       if (response) {
      //         this.loginForm.reset();
      //         // Si el usuario es rol proveedor, redirige a la ficha de su proveedor, caso contrario al inicio
      //         if (response.rol === RolUsuario.Proveedor) {
      //           this.navCtrl.navigateRoot([
      //             `/proveedores/proveedor-ficha/${response.idProveedor}`,
      //           ]);
      //         } else {
      //           this.navCtrl.navigateRoot(['/']);
      //         }
      //       } else {
      //         //Marcar el formulario como inválido
      //         this.loginForm.invalid;
      //       }
      //     },
      //     error: (error) => {
      //       // Gestionar errores especificos de login
      //       if (error.status === 401 || error.status === 404) {
      //         this.loginForm.controls.correo.setErrors({
      //           credencialesInvalidas: true,
      //         });
      //         this.loginForm.controls.clave.setErrors({
      //           credencialesInvalidas: true,
      //         });
      //       } else if (error.status === 403) {
      //         this.loginForm.controls.correo.setErrors({
      //           accesoDenegado: true,
      //         });
      //       }
      //       //Mostrar mensaje de error
      //       this.snackBarService.showError(error.error);
      //       this.loading = false;
      //     },
      //   });
    // }
  }

  //Funcion para iniciar sesion con 2FA
  factor2FA() {
    this.Acceso2FA.emit();
  }

  //Funcion que se encarga de limpiar ciertos errores específicos de los controles del formulario
  //(usuario y clave) cuando se detecta un cambio en el input.
  onInputChange() {
    if (!this.loginForm) return;

    const correoControl = this.loginForm.controls.correo;
    const claveControl = this.loginForm.controls.clave;

    if (
      correoControl.errors?.['credencialesInvalidas'] ||
      correoControl.errors?.['accesoDenegado']
    ) {
      correoControl.setErrors(null);
    }

    if (
      claveControl.errors?.['credencialesInvalidas'] ||
      claveControl.errors?.['accesoDenegado']
    ) {
      claveControl.setErrors(null);
    }
  }

  // Enviar el formulario al presionar Enter en el campo de contraseña
  onKeydownContrasena(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      //Espera el tiempo minimo para que los cambios en contraseña se registren
      setTimeout(() => {
        this.onSubmit();
      }, 0);
    }
  }

  onRestablecerContra() {
    this.RestablecerContrasena.emit();
  }
}
